import assign from "lodash/assign";

const modal = {
  hideModal: "modal/hideModal",
  showModal: "modal/showModal",
};

const usuario = {
  guardarUsuario: "usuario/guardar",
  setUsuario: "usuario/setUsuario",
  resetUsuario: "usuario/resetUsuario",
};

const formulario = {
  getBaseFormulario: "formulario/getBase",
  guardarFormulario: "formulario/guardar",
  setFormulario: "formulario/setFormulario",
  resetFormulario: "formulario/resetFormulario",
  eliminarFormulario: "formulario/deleteID",
  actualizarBorradores: "formulario/actualizarBorradores",
  eliminarBorrador: "formulario/eliminarBorrador",
  postImagen: "formulario/postImagen",
  getImgsForm: "formulario/getImgsForm",
};

const seguimiento = {
  getBaseSeguimiento: "seguimiento/getBase",
  guardarSeguimiento: "seguimiento/guardar",
  setSeguimiento: "seguimiento/setSeguimiento",
  resetSeguimiento: "seguimiento/resetSeguimiento",
  eliminarSeguimiento: "seguimiento/deleteID",
  actualizarTemporales: "seguimiento/actualizarTemporales",
  eliminarTemporal: "seguimiento/eliminarTemporal",
};

function accionesMenu() {
  return {
    alternarMenu: "nav/alternarMenu",
  };
}

export default assign(modal, usuario, formulario, seguimiento, accionesMenu());
